export default __webpack_public_path__ + "static/media/ambulance-management-system.7ee72764.jpg";